module.exports = __webpack_public_path__ + "img/turtle.559ba01a.png";